var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasElementsInConfig
    ? _c(
        "div",
        { staticClass: "table" },
        [
          _c("div", { staticClass: "table__content" }, [
            _c(
              "div",
              {
                staticClass: "table__content-wrapper",
                style: _vm.percentageWidth ? "width: 100%" : ""
              },
              [
                _c("TableHeader", {
                  attrs: {
                    config: _vm.config,
                    "order-by": _vm.orderBy,
                    "sort-direction": _vm.sortDirection
                  },
                  on: {
                    "update-sort": _vm.updateSort,
                    "update-filters": _vm.updateFilters,
                    "change-order": _vm.changeColumnOrder
                  }
                }),
                _vm._v(" "),
                _c("TableBody", {
                  attrs: {
                    config: _vm.config,
                    "table-data": _vm.tableData,
                    "clickable-rows": _vm.clickableRows
                  },
                  on: {
                    "row-click": function(val) {
                      return _vm.$emit("row-click", val)
                    },
                    "btn-click": function(val) {
                      return _vm.$emit("btn-click", val)
                    },
                    "delete-row": function(val) {
                      return _vm.$emit("delete-row", val)
                    }
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("TableFooter", {
            attrs: {
              config: _vm.config,
              "current-page": _vm.currentPage,
              pages: _vm.pages
            },
            on: {
              "change-page": _vm.changePageHandler,
              "update-column": _vm.updateColumnHandler,
              "reset-settings": _vm.resetSettingsHandler
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }